import { Helmet } from 'react-helmet-async';
import { useParams, useSearchParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { invoicesColumns } from './_authenticated._main.invoicing.invoices/utils';
import { TransactionStateBadge } from './_authenticated._main.invoicing.transactions/TransactionStateBadge';
import { ErrorPage } from '../components/error-page/ErrorPage';
import { Spinner } from '../components/Spinner';
import { Table } from '../components/table/Table';
import { useFetchTransaction } from '../hooks/useFetchTransaction';
import { TRANSACTION_INVOICES_LIMIT, useFetchTransactionInvoicesPage } from '../hooks/useFetchTransactionInvoices';
import { t } from '../services/translation/translation';
import { formatDate } from '../utils/date';
import { formatPrice } from '../utils/price';

export const TransactionRoute = () => {
  const { transactionId } = useParams();
  const [searchParams] = useSearchParams();

  invariant(transactionId);

  const { data: transaction, isLoading: isLoadingTransaction } = useFetchTransaction(transactionId);

  const currentPage = Math.max(parseInt(searchParams.get('page') ?? '1'), 1);
  const { data, isLoading, isFetching, isPreviousData } = useFetchTransactionInvoicesPage(
    { transactionId },
    currentPage,
  );
  const nbPages = Math.ceil((data?.totalItems ?? 0) / TRANSACTION_INVOICES_LIMIT);

  if (isLoadingTransaction) {
    return (
      <div>
        <Helmet>
          <title>{t('common.transfer')} - Allocab</title>
        </Helmet>
        <Spinner />
      </div>
    );
  }

  if (!transaction) {
    return <ErrorPage />;
  }

  return (
    <div>
      <Helmet>
        <title>
          {t('transaction-route.helmet-title', { date: formatDate(transaction.updatedAt, t('date.date-short')) })} -
          Allocab
        </title>
      </Helmet>
      <div className="flex items-center mb-6 gap-4">
        <h3 className="text-3xl font-bold dark:text-white ">
          {t('transaction-route.title', {
            amount: formatPrice(transaction.amount),
            date: formatDate(transaction.updatedAt, t('date.date-longer')),
          })}
        </h3>
        <TransactionStateBadge status={transaction.status} />
      </div>

      <h6 className="text-lg font-bold dark:text-white mb-2">{t('common.invoices')}</h6>

      <Table
        columns={invoicesColumns}
        data={data?.items}
        identifier="id"
        isLoading={isLoading}
        isFetching={isPreviousData && isFetching}
        nbPages={nbPages}
        context={undefined}
        totalItems={data?.totalItems ?? 0}
      />
    </div>
  );
};
